import React, {Suspense} from "react";
import ReactDOM from "react-dom";
import GiftBlock from "./GiftBlock";

class GiftBlockPortal {
  public static run(element: HTMLDivElement): void {
    ReactDOM.render(
      <Suspense fallback={null}>
        <GiftBlock />
      </Suspense>,
      element,
    );
  }
}

export default GiftBlockPortal;
